import { zodResolver } from "@hookform/resolvers/zod";
import { LocationFormProps } from "data/reduxInterfaces";
import { FC, Fragment, HTMLAttributes, useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import Textarea from "shared/Textarea/Textarea";
import { z } from "zod";

const formSchema = z.object({
  description: z
    .string({
      required_error: "Ce champs est obligatoire.",
      invalid_type_error: "Ce champs est obligatoire.",
    })
    .min(10, {
      message: "La description est obligatoire et doit contenir au minimum 10 caractères.",
    }),
});

const LocationDescription: FC<LocationFormProps & HTMLAttributes<HTMLDivElement>> = ({
  isLoading,
  handleForm,
  data,
  FormData,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      description: data?.description ?? "",
    },
    mode: "onChange",
  });

  useEffect(() => {
    if (data) {
      setValue("description", data.description);
    }
  }, [data]);

  useEffect(() => {
    console.log("🔥 LocationDescription - Event received:", handleForm?.type);
    if (handleForm.type === "chekLocationFormSeven") {
      console.log("🔥 LocationDescription - Event chekLocationFormSeven triggered");
      console.log("🔥 Current form data:", data);
      console.log("🔥 Form errors:", errors);
      // Déclencher immédiatement sans délai
      handleSubmit(onSubmit)();
    }
  }, [handleForm]);

  const onSubmit: SubmitHandler<z.infer<typeof formSchema>> = (data) => {
    console.log("🔥 LocationDescription onSubmit - données reçues:", data);
    console.log("🔥 Description length:", data.description?.length);

    // Validation manuelle supplémentaire
    if (!data.description || data.description.trim().length < 10) {
      console.log("❌ Description validation failed - too short or empty");
      return; // Ne pas soumettre si la validation échoue
    }
    console.log("✅ Description validation passed, sending data");
    FormData(data);
  };

  return (
    <Fragment>
      <form className="w-full" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="w-full">
          <div>
            <h2 className="text-2xl font-semibold">Description de votre espace</h2>
          </div>

          <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>

          <div className="space-y-8 mt-5">
            <div>
              <span className="block mt-2 text-sm text-neutral-500 dark:text-neutral-400">
                Décrivez votre espace aux visiteurs. Rédigez un bref résumé en mettant en avant les
                caractéristiques de votre espace.
              </span>
            </div>
            <Textarea
              disabled={isLoading}
              placeholder="..."
              rows={14}
              {...register("description", { required: false })}
              required={false}
            />
            {errors.description?.message && (
              <div className="text-xs text-red-500">{`${errors.description?.message}`}</div>
            )}
          </div>
        </div>
      </form>
    </Fragment>
  );
};

export default LocationDescription;
